import ContainerMd from "../../components/Layouts/ContainerMd";
import { useNavigate } from "react-router-dom";
import UserSanadsInfo from "../tutor/dashboard/PersonalInfo/SanadsInfo";
import { useTranslation } from "react-i18next";
import { SANAD_INFO_STEP_INDEX, TUTOR_STEPS } from "./completeAccountUtils";

export default function SanadInfo() {
  const { t } = useTranslation();
  const navigate = useNavigate();
  let previousButtonText = '';

  let submitButtonText = `${t("page.steps.next")}: ${t(
    TUTOR_STEPS[SANAD_INFO_STEP_INDEX + 1].name
  )}`;
  if(SANAD_INFO_STEP_INDEX > 0) {
    previousButtonText = `${t("page.steps.previous")}: ${t(
      TUTOR_STEPS[SANAD_INFO_STEP_INDEX - 1].name
    )}`;
  }
  
  let stepInfo = `${SANAD_INFO_STEP_INDEX + 1} ${t("page.steps.of")} ${
    TUTOR_STEPS.length
  }`;

  return (
    <ContainerMd className={"flex-1 flex flex-col"}>
      <UserSanadsInfo
        onContinue={() =>
          navigate(TUTOR_STEPS[SANAD_INFO_STEP_INDEX + 1].route)
        }
        prevPage={() =>navigate(TUTOR_STEPS[SANAD_INFO_STEP_INDEX - 1].route)}
        showLogo={true}
        showHeader={true}
        submitButtonText={submitButtonText}
        previousButtonText={previousButtonText}
        stepInfo={stepInfo}
      />
    </ContainerMd>
  );
}
